import React, { useRef } from "react";
import { FiDownload } from "react-icons/fi";
import { downloadCSV } from "../utils/downloadHelpers";

/**
 * Renderer for plain markdown <table> elements (i.e. tables produced by
 * remark-gfm rather than CSV-fenced blocks). The CSV is reconstructed from
 * the rendered DOM at download time.
 */
const TableComponent = ({ node, ...props }) => {
  const tableRef = useRef(null);

  return (
    <div className="table-wrapper">
      <div className="scrollable-table-container">
        <table className="data-table" ref={tableRef} {...props} />
      </div>
      <button
        className="download-csv-button"
        onClick={() => downloadCSV(tableRef)}
      >
        Download CSV
        <FiDownload aria-hidden="true" />
      </button>
    </div>
  );
};

export default TableComponent;
